import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {productCategoryActions} from "./productCategorySlice";
import {productCategoryApi} from "~/api";

function* fetchProductCategoryList(action) {
    try {
        const response = yield call(productCategoryApi.gets, action.payload);
        yield put(productCategoryActions.fetchDataSuccess(response))
    }
    catch (error) {
        console.log('Failed to fetch product category list', error);
        yield put(productCategoryActions.fetchDataFailed(error.message));
    }
}

function* handleSearchDebounce(action) {
    yield put(productCategoryActions.setFilter(action.payload));
}

export default function* productCategorySaga() {
    yield takeLatest(productCategoryActions.fetchData.type, fetchProductCategoryList);
    yield debounce(500, productCategoryActions.setFilterWithDebounce.type, handleSearchDebounce)
}

